export const PERFILADOR_DEFAULT_TABS = [
  {
    label: 'Precio de inmueble',
    value: 'PRECIO_INMUEBLE',
    disabled: false,
  },
];

export const PERFILADOR_TABS_PRECIO_INGRESOS = [
  {
    label: 'Precio de inmueble',
    value: 'PRECIO_INMUEBLE',
    disabled: false,
  },
  {
    label: 'Ingresos mensuales',
    value: 'INGRESOS_MENSUALES',
    disabled: false,
  },
];

export const DEFAULT_PERFILADOR_LANDING_CONFIG = {
  footerText: 'Vamos dando juntos el primer paso para encontrar tu opción óptima',
  buttonText: 'Cotización personalizada',
};
